<template>
  <div id="footer" class="text-sm">
    <hr id="footer-hr" class="mb-10">
    <div class="ui middle aligned center aligned equal width stackable grid">
      <div class="column">
        <div>微信公众号: 红豆云助手</div>
        <img class="mx-auto" src="../assets/qrcode.jpg" width="129" height="129" alt=""/>
      </div>
      <div id="texts" class="column">
        <div><a href="http://www.beian.miit.gov.cn" class="" target="_blank">沪ICP备20013670号-1</a></div>
        <div>© 2020 hondcloud.com</div>
        <div>客服邮箱: <a href="mailto:service@hondcloud.com" class="" target="_blank">service@hondcloud.com</a></div>
        <div>上海又枫科技有限公司</div>
        <div>上海市奉贤区金海公路4808弄30号408室</div>
        <div>电话：18636001916 / 021 - 64889921</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheFooter',
  props: [],
  components: {
  },
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
}
</script>

<style scoped>
#footer {
  margin-top: 150px;
  margin-bottom: 30px;
}
#texts div {
  margin-bottom: 13px;
}
</style>
